import script from "./claimListPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./claimListPopup.vue?vue&type=script&setup=true&lang=ts"

import "./claimListPopup.vue?vue&type=style&index=0&id=ecd6f662&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecd6f662"]])

export default __exports__